import { Dropdown, Flex } from 'antd';
import { ChevronDown } from 'lucide-react';
import Link from 'next/link';
import { FC } from 'react';
import styles from './BlogMenu.module.scss';
import { BlogMenuProps } from './BlogMenu.props';

export const BlogsMenu: FC<BlogMenuProps> = (props) => (
  <Dropdown
    classNames={{ root: styles.dropdown }}
    {...props}
    menu={{
      items: [
        {
          key: 'blog',
          label: (
            <Link href="/blog" rel="noopener">
              Blog
            </Link>
          ),
        },
        {
          key: 'news',
          label: (
            <Link href="/blog/category/news" rel="noopener">
              News
            </Link>
          ),
        },
      ],
    }}
  >
    <Flex align="center" gap={8}>
      <span>Blogs</span>
      <ChevronDown size={16} />
    </Flex>
  </Dropdown>
);
